import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import GeneralNotificationContext from "../../context/general-notification/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import GeneralNotificationContextProvider from "../../context/general-notification/provider";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import GeneralNotificationTable from "../../components/general-notification/general-notification-table";
import GeneralNotificationFilter from "../../components/general-notification/general-notification-filter";

interface IProps {
  children?: React.ReactNode;
}

// sum array in js
const GeneralNotification: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(GeneralNotificationContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("generals_notification")}
        subTitle={t("generals_notification_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/general-notification/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_general_notification")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="general-notification-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <GeneralNotificationFilter />
      </SearchFilterCard>

      <GeneralNotificationTable />
    </div>
  );
};

const GeneralNotificationPage = () => {
  return (
    // ContextProvider
    <GeneralNotificationContextProvider>
      <GeneralNotification />
    </GeneralNotificationContextProvider>
  );
};
export default GeneralNotificationPage;
